export function isRecord(element) {
    const assumedRecord = element;
    return assumedRecord.Entries !== undefined;
}
export function isAmendment(element) {
    const assumedAmendment = element;
    return assumedAmendment.Changes !== undefined;
}
export function isApproval(element) {
    const assumedApproval = element;
    return assumedApproval.ApprovedObjects !== undefined;
}
export function isFileDescriptor(element) {
    const assumedFileDescriptor = element;
    return assumedFileDescriptor.FileName !== undefined;
}
export function isVesselParticulars(element) {
    const assumedVesselParticulars = element;
    return assumedVesselParticulars.SignedBy !== undefined;
}
export function isVoyage(element) {
    const assumedVoyage = element;
    return assumedVoyage.VoyageNumber !== undefined;
}
export function isBookKeyBundle(element) {
    const assumedBookKeyBundle = element;
    return assumedBookKeyBundle.Book !== undefined;
}
export function isCrewList(element) {
    const assumedCrewList = element;
    return assumedCrewList.CrewMembers !== undefined;
}
export function isReplaceChange(change) {
    return change.Operation === 'replace';
}
export function isDeleteChange(change) {
    return change.Operation === 'delete';
}
//# sourceMappingURL=Guards.js.map